import React, { Component } from 'react';
import { ProductInfoForm } from 'components';
import { PageContainer } from 'pages';

class AddProductPage extends Component {
 render() {
   return (
     <PageContainer maxHeight>
       <ProductInfoForm />
     </PageContainer>
   );
 }
}

export default AddProductPage;
